import React, { useContext, useState } from 'react'
import Sidebar from '../components/Sidebar'
import Navbar from '../components/Navbar'
import Container from '../components/Container'
import Alert from '../components/Alert'
import Notifications from '../section/Notifications'
import { USER_CONTEXT } from '../context/ContextProvider'

const RootLayout = ({ children }) => {
  let [open, setOpen] = useState(false)
  let { data } = useContext(USER_CONTEXT)
  return (
    <div className="flex font-dm">
      <Sidebar open={open} setOpen={setOpen} />
      <div className="w-full">
        <Navbar open={open} setOpen={setOpen} />
        <Container>
          <Notifications>
            {data.notifications?.map((notification) => (
              <Alert notification={notification} />
            ))}
          </Notifications>
          {children}
        </Container>
      </div>
    </div>
  )
}

export default RootLayout
